import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=49867202&"
import script from "./MessageBox.js?vue&type=script&lang=js&"
export * from "./MessageBox.js?vue&type=script&lang=js&"
import style0 from "./MessageBox.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports